import { render, staticRenderFns } from "./TipCreate.vue?vue&type=template&id=64ebf5d4&"
import script from "./TipCreate.vue?vue&type=script&lang=js&"
export * from "./TipCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports